import { Injectable, Inject, Injector } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { JL } from 'jsnlog';
import { Router } from '@angular/router';
import { UsuarioAutenticado } from '../shared/models/UsuarioAutenticado';
import { tap, shareReplay, catchError, map } from 'rxjs/operators';
import * as moment from "moment";
import { UsuarioLogin } from '../shared/models/UsuarioLogin';
import { Response } from '../shared/models/Response';
import { of } from 'rxjs';
import { Form } from '@angular/forms';
import { SharedService } from '../shared/shared.service';
import { ResetPassword } from '../shared/models/ResetPassword';
import { UpdatePassword } from '../shared/models/UpdatePassword';
import { Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class CoreService {
  titulo: string = "Home";
  activo: string = "home";
  JL: JL.JSNLog;
  uri: string;

  //No puedo inyectar el jsnlog como dependencia
  constructor(private injector: Injector, private http: HttpClient, public sharedService: SharedService, private titleService: Title) {
  }

  public get router(): Router { //this creates router property on your service.
    return this.injector.get(Router);
  }

  public setTitle(newTitle: string) {
    this.titleService.setTitle(newTitle);
  }

  public isMobile() {
    var ua = navigator.userAgent;
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(ua)) {
      return true;
    } else {
      return false;
    }
  }

  public login(credentials: UsuarioLogin) {
    return this.http.post<Response>(this.sharedService.WebURL + '/Auth/SignIn', credentials)
      .pipe(tap(res => this.setSession(res.data))
        , shareReplay()
        , catchError(e => of(new Response(0, "Error, no ha sido posible realizar el login", null))));
  }

  public setSession(authResult) {
    if (authResult != null) {
      const expiresAt = moment().add(authResult.expiresIn, 'second');

      localStorage.setItem('id_token', authResult.access_token);
      localStorage.setItem("expires_at", JSON.stringify(expiresAt.valueOf()));
      localStorage.setItem("username", authResult.username);
      localStorage.setItem("rol", authResult.rol);
      localStorage.setItem("email", authResult.email);

      this.getUserInfo().subscribe(result => {
        if (result.response_code >= 0) {
          localStorage.setItem("entityName", result.data.nombre);
          if (authResult.rol == "explotacion") {
            localStorage.setItem("empresa", result.data.empresa);
          }
        } else {
          this.logout();
        }
      });
    }
  }

  logout() {
    if (this.getUserRol() == "explotacion") {
      localStorage.removeItem("empresa");
    }
    localStorage.removeItem("id_token");
    localStorage.removeItem("expires_at");
    localStorage.removeItem("username");
    localStorage.removeItem("rol");
    localStorage.removeItem("entityName");
    this.router.navigate(['/identificate']);
  }

  public isLoggedIn() {
    return moment().isBefore(this.getExpiration());
  }

  getExpiration() {
    const expiration = localStorage.getItem("expires_at");
    const expiresAt = JSON.parse(expiration);
    return moment(expiresAt);
  }

  isLoggedOut() {
    return !this.isLoggedIn();
  }


  public getUserName() {
    return localStorage.getItem("username");
  }

  public getUserRol() {
    return localStorage.getItem("rol");
  }

  public getUserEmail() {
    return localStorage.getItem("email");
  }

  public getEntityName() {
    return localStorage.getItem("entityName");
  }

  public getEmpresaExplotacion() {
    if (this.getUserRol() == "explotacion") {
      return localStorage.getItem("empresa");
    } else {
      return "";
    }
  }

  public getUserInfo() {
    return this.http.get<Response>(this.sharedService.WebURL + '/User/GetUserInfo')
      .pipe(
        catchError((err: HttpErrorResponse) => {
          //this.JL().error(err);
          return of(new Response(-1, "Error, no se ha sido posible completar la petición", null));
        })
      );
  }

  public sendRecoveryEmail(email: string) {
    return this.http.get<Response>(this.sharedService.WebURL + '/User/SendRecoveryEmail/' + email)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          //this.JL().error(err);
          return of(new Response(-1, "Error, no se ha sido posible completar la petición", null));
        })
      );
  }

  //Enviamos la nueva contraseña con el token generado en el correo
  public resetPassword(resetPassword: ResetPassword) {
    return this.http.post<Response>(this.sharedService.WebURL + '/User/ResetPassword', resetPassword)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          //this.JL().error(err);
          return of(new Response(-1, "Error, no se ha sido posible cambiar la contraseña", null));
        })
      );
  }

  //Enviamos la nueva contraseña con el token generado en el correo
  public updatePasswod(updatePassword: UpdatePassword) {
    return this.http.post<Response>(this.sharedService.WebURL + '/User/UpdatePassword', updatePassword)
      .pipe(
        catchError((err: HttpErrorResponse) => {
          //this.JL().error(err);
          return of(new Response(-1, "Error, no se ha sido posible actualizar la contraseña", null));
        })
      );
  }


}
